import axios from 'axios'

// state
export const state = {
  statistics: {}
}

// getters
export const getters = {
  statistics: state => {
    return state.statistics
  },

  /**
   * Return Modules from store modules
   *
   * @param state
   * @param getters
   * @param rootState
   */
  getStoreModules: (state, getters, rootState) => {
    return rootState.modules.modules
  },

  /**
   * Return accessories
   *
   * @param state
   * @returns {Array}
   */
  statisticsAccessories: state => {
    if (!state.statistics.data) return []

    let statisticAccessories = getAccessories(state.statistics.data.statistic)

    statisticAccessories.sort((a, b) => (a.pivot.quantity > b.pivot.quantity) ? -1 : 1)

    return statisticAccessories
  }
}

// mutations
export const mutations = {
  fetchStatistics (state, { statistics }) {
    state.statistics = statistics
  }
}

// actions
export const actions = {
  async fetchStatistics ({ commit }, payload) {
    try {
      const { data } = await axios.post('/api/statistic/index', { start: payload.start, end: payload.end })
      commit('fetchStatistics', { statistics: data })
    } catch (e) {
    }
  },

  async sendStatistics ({ commit }, payload) {
    try {
      axios.post('/api/statistic', payload)
    } catch (e) {
    }
  },

  async exportStatistic ({ commit }, payload) {
    try {
      axios({
        url: '/api/statistic/export',
        method: 'GET',
        responseType: 'blob', // important
        params: {
          start: payload.start,
          end: payload.end
        }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'statistic.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    } catch (e) {
    }
  }
}

function getQuestions (statistic) {
  let questionStatisticObject = []

  statistic.filter(function (value) {
    questionStatisticObject.push(value.answers)
  })

  return questionStatisticObject
}

function getAccessories (statistic) {
  let accessoriesStatisticObject = []

  statistic.filter(function (value) {
    accessoriesStatisticObject.push(value.accessories)
  })

  return mergeAccessories(accessoriesStatisticObject)
}

function mergeAccessories (statistics) {
  var mergedStatistics = [].concat.apply([], statistics)

  return sortAccessories(mergedStatistics)
}

function sortAccessories (mergedStatistics) {
  let sortArray = []

  for (var i = 0; i < mergedStatistics.length; i++) {
    let findIndex = sortArray.findIndex(x => x.id === mergedStatistics[i].id)

    findIndex >= 0
      ? sortArray[findIndex].pivot.quantity += mergedStatistics[i].pivot.quantity
      : sortArray.push(mergedStatistics[i])
  }

  return sortArray
}

function findGroupByID (questionStatisticObject, questions) {
  var mergedStatistics = [].concat.apply([], questionStatisticObject)

  let uniqAnswersId = [...new Set(mergedStatistics.map(x => x.answer_id))]

  return findSameQuestions(uniqAnswersId, mergedStatistics, questions)
}

function findSameQuestions (uniqAnswersId, mergedStatistics, questions) {
  for (var i = 0; i < uniqAnswersId.length; i++) {
    if (uniqAnswersId[i] === -1) continue

    let count = mergedStatistics.filter(question => question.answer_id === uniqAnswersId[i])

    questions[findAnswerInQuestion(questions, uniqAnswersId[i])].answers.find(answer => answer.id === count[0].answer_id).count = count.length
  }

  return questions
}

function findAnswerInQuestion (questions, answerId) {
  for (var i = 0; questions.length; i++) {
    if (questions[i].answers.find(answer => answer.id === answerId)) {
      return i
    }
  }
}

function getModules (storeModules) {
  let modules = state.statistics.data.statistic

  let sortModules = []

  for (var i = 0; i < modules.length; i++) {
    sortModules = sortModules.concat(findAddModulesInModule(modules[i].modules, storeModules))
  }

  sortModules = findAddModulesInModule(sortModules, storeModules)

  sortModules = findModulesByIdentifier(sortModules, storeModules)

  return sortModules
}

function findAddModulesInModule (modules, storeModules) {
  var sorModules = []

  for (var i = 0; i < modules.length; i++) {
    let findModule = Object.keys(modules[i]).length === 1 ? storeModules.find(module => module.id === modules[i].id) : modules[i]

    let findIndex = sorModules.findIndex(module => module.id === findModule.id)

    if (findIndex >= 0) {
      sorModules[findIndex].count += 1
    } else {
      if (!findModule.hasOwnProperty('count')) findModule.count = 1

      sorModules.push(findModule)
    }
  }

  return sorModules
}

function findModulesByIdentifier (modules) {
  var sorModules = []

  for (var i = 0; i < modules.length; i++) {
    let findIndex = sorModules.findIndex(module => module.identifier === modules[i].identifier)

    findIndex >= 0
      ? sorModules[findIndex].count += 1
      : sorModules.push(modules[i])
  }

  return sorModules
}

function getColor () {
  let sortColor = []

  let statistic = state.statistics.data.statistic

  for (var i = 0; i < statistic.length; i++) {
    let findIndex = -1
    findIndex = sortColor.findIndex(color => parseInt(color.item) === parseInt(statistic[i].color))

    findIndex >= 0
      ? sortColor[findIndex].count += 1
      : sortColor.push(getObj(parseInt(statistic[i].color)))
  }

  return sortColor
}

function getObj (item) {
  let obj = {}

  obj.item = item

  obj.count = 1

  return obj
}

function getSize () {
  let sortSize = []

  let size = state.statistics.data.statistic

  for (var i = 0; i < size.length; i++) {
    let findIndex = -1
    findIndex = sortSize.findIndex(x => parseInt(x.item) === parseInt(size[i].size))

    findIndex >= 0
      ? sortSize[findIndex].count += 1
      : sortSize.push(getObj(parseInt(size[i].size)))
  }

  return sortSize
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/statistics.js